exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* Main CSS styles for Sectors */\n.bg-gray-100 {\n  background-color: #f8f9fa;\n}\n\n.sector-container {\n  padding: 40px 0;\n}\n\n.sector-heading {\n  color: #5a2684;\n  margin-bottom: 1.5rem;\n}\n\n.sector-image {\n  width: 100%;\n  height: auto;\n  border-radius: 4px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/Main.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/Main.css
// module chunks = 0